import React from "react";
import SearchZone from "./SearchZone";
import PriceRange, { PRICE_MAX } from "./PriceRange";
import FeaturedZones from "./FeaturedZones";

import { HeatMapV2Data } from "../../models/heatMapModel";

const COUNTRY_NAMES: Record<string, string> = {
  sv: "El Salvador",
  gt: "Guatemala",
  pa: "Panamá",
};

interface Props {
  country: string;
  data: HeatMapV2Data | null;
  priceMin: number;
  priceMax: number;
  onPriceMinChange: (v: number) => void;
  onPriceMaxChange: (v: number) => void;
  onZoneSelect?: (zone: { id: number; name: string }) => void;
}

const Sidebar: React.FC<Props> = ({ country, data, priceMin, priceMax, onPriceMinChange, onPriceMaxChange, onZoneSelect }) => {
  const countryName = COUNTRY_NAMES[country] ?? country;
  const rangeMax = data?.max_price_range_value ?? PRICE_MAX;

  return (
    <div className="dynamic order-1 md:order-2 flex justify-center md:justify-start px-2 md:px-4 w-full md:w-[408px] flex-1 overflow-y-auto md:mb-6 pointer-events-none">
      <div className="w-full flex flex-col gap-4 overflow-y-auto">
        <div className="pointer-events-auto bg-[#002412]/40 backdrop-blur-sm border border-white/30 rounded-xl text-white w-full [box-shadow:0_25px_50px_-12px_rgba(0,0,0,0.25),inset_4px_4px_14px_rgba(0,0,0,0.3),1px_1px_1px_rgba(255,255,255,0.14)]">
          {/* Header — visible en ambos */}
          <div className="px-4 pt-4 md:pt-6 mb-2 md:pb-4">
            <h1 className="text-xl md:text-4xl font-bold leading-tight tracking-tight">
              Mapa de precios <br />
              {countryName}
            </h1>
            <p className="text-sm md:text-base text-white md:mt-1">Explora precios promedio por m² por zona</p>
          </div>

          {/* Buscador — visible en ambos */}
          <div className="px-4 pb-4">
            <SearchZone zones={data?.polygons} onSelect={onZoneSelect} />
          </div>

          {/* Rango de precio — solo web */}
          <div className="hidden md:block px-4 pb-4">
            <p className="text-base text-white mb-1">Rango de precio por m²</p>
            <PriceRange rangeMin={0} rangeMax={rangeMax} min={priceMin} max={priceMax} onMinChange={onPriceMinChange} onMaxChange={onPriceMaxChange} />
          </div>

          {/* Zonas destacadas — solo web */}
          <div className="hidden md:block px-4 pb-4">
            <FeaturedZones zones={data?.featured_polygons} onSelect={onZoneSelect} />
          </div>

        </div>

      </div>
    </div>
  );
};

export default Sidebar;
